import { LOGGING } from '../../config/client.config';

const pushData = (data: Object): void => {
  if (window?.dataLayer) {
    window.dataLayer.push(data);

    if (LOGGING) {
      console.info('dataLayer.push', data); // eslint-disable-line
    }
  } else {
    if (LOGGING) {
      console.info('Ignoring dataLayer.push request on server side', data); // eslint-disable-line
    }
  }
};

interface DataLayer {
  isAuthenticated: boolean;
  country: string;
  language: string;
  pageCategory: string;
}

export const pushUserData = ({
  isAuthenticated,
  country,
  language,
  pageCategory,
}: DataLayer): void => {
  pushData({
    authentication: isAuthenticated ? 'Logged in' : 'Anonymous',
    country,
    lang: language,
    pageCategory,
    pageUrl: window.location.href,
  });
};

interface Product {
  productId?: string | null;
  productName?: string | null;
  quantity?: number | null;
  price?: number | null;
  category: string;
  subCategory: string;
}

export const pushFunnelEvent = (step: string, products?: Product[]) => {
  pushData({ products: null });
  pushData({
    event: 'funnel',
    step,
    type: '',
    products,
  });
};

export const pushEcommerceEvent = (action: string, ecommerce: Object): void => {
  pushData({
    ecommerce: null,
  });
  pushData({
    event: 'analyticsEvent',
    eventCategory: 'Ecommerce',
    eventAction: action,
    ecommerce,
  });
};

export { pushData };
